import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

export type SkeletonTabsProps = {
    tabs?: number
}

export default function SkeletonTabs(props: Readonly<SkeletonTabsProps>) {
    const { tabs = 5 } = props

    return (
        <Stack
            direction="row"
            spacing={3}
            sx={{
                px: 1,
                pb: 1.5,
                borderBottom: '1px solid',
                borderColor: 'divider',
                overflow: 'hidden',
            }}
        >
            {Array.from({ length: tabs }, (_, index) => (
                <Skeleton key={index} variant="text" width={90 + ((index * 23) % 60)} />
            ))}
        </Stack>
    )
}
